import { IndexForm } from "./index.types";

export const flattenForm = (form: IndexForm) => [
  ...form.devices,
  ...form.indexProducts,
  ...form.indexServices,
  ...form.indexTravel,
];
